import { render } from "./PopupTemplate.vue?vue&type=template&id=acb139f2"
import script from "./PopupTemplate.vue?vue&type=script&lang=js"
export * from "./PopupTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__